import React from 'react';
import {
  Switch,
  Route,
  RouteComponentProps,
  Redirect,
  withRouter,
} from 'react-router-dom';
import { RtbCampaignsProps } from './RtbCampaignsModel';
import { RtbCampaignSetupFlowPage } from './RtbCampaignSetupFlow/RtbCampaignSetupFlowPage';
import RtbCampaignSelectAdTypePage from 'containers/RtbCampaigns/RtbCampaignSelectAdType/RtbCampaignSelectAdTypePage';
import RtbCampaignSinglePage from 'containers/RtbCampaigns/RtbCampaignSinglePage/RtbCampaignSinglePage';
import styles from './rtbCampaigns.module.scss';
import {
  addOnEnabled,
  hasFuncs,
  notSettleOrder,
} from 'core/permission/PermissionDSL';
import { Permission } from 'core/auth/Permission';
import PermissionChecker from 'containers/PermissionChecker/PermissionChecker';
import { ROUTE_PATH } from 'enum/RoutePath';
import { withErrorBoundary } from 'hoc/withErrorBoundary';
import { ERROR_CODE } from 'core/ErrorCode';
import CoreContext from 'contexts/coreContext';
import _ from 'lodash';
import { ADDONFEATURE } from 'core/agency/AddonFeature';
import { PermissionItem } from 'core';
import { useCampaignStore } from 'store/campaignStore';
const SelectAdTypeView = withErrorBoundary(
  ERROR_CODE.SELECT_ADTYPE,
  RtbCampaignSelectAdTypePage,
);
const NewCreateCampaignView = withErrorBoundary(
  ERROR_CODE.CAMPAIGN_CREATE,
  RtbCampaignSinglePage,
);
const CreateCampaignView = withErrorBoundary(
  ERROR_CODE.CAMPAIGN_CREATE,
  RtbCampaignSetupFlowPage,
);
const EditCampaignView = withErrorBoundary(
  ERROR_CODE.CAMPAIGN_EDIT,
  RtbCampaignSinglePage,
);
const CopyCampaignView = withErrorBoundary(
  ERROR_CODE.CAMPAIGN_COPY,
  RtbCampaignSinglePage,
);
const SplitCampaignView = withErrorBoundary(
  ERROR_CODE.CAMPAIGN_SPLIT,
  RtbCampaignSetupFlowPage,
);
class DefaultRtbCampaigns extends React.Component<
  RouteComponentProps<any> & RtbCampaignsProps
> {
  modifyPermission: PermissionItem;

  constructor(props: RouteComponentProps<any> & RtbCampaignsProps) {
    super(props);
    this.modifyPermission = hasFuncs(Permission.CAMPAIGN_WRITE)
      .and(addOnEnabled(ADDONFEATURE.CHANNEL[props.model.channel]))
      .and(notSettleOrder(props.model.order));
  }

  renderSelectAdTypeView = (localeMeta, props) => {
    return (
      <PermissionChecker
        permissionAware={this.modifyPermission}
        redirectTo={`${props.match.url}/${ROUTE_PATH.ERROR403}`}
      >
        <SelectAdTypeView />
      </PermissionChecker>
    );
  };

  renderNewCreateCampaignView = (localeMeta, props) => {
    return (
      <PermissionChecker
        permissionAware={this.modifyPermission}
        redirectTo={`${props.match.url}/${ROUTE_PATH.ERROR403}`}
      >
        <NewCreateCampaignView actionType={'create'} />
      </PermissionChecker>
    );
  };

  renderNewEditCampaignView = (localeMeta, props) => {
    return (
      <PermissionChecker
        permissionAware={this.modifyPermission}
        redirectTo={`${props.match.url}/${ROUTE_PATH.ERROR403}`}
      >
        <EditCampaignView actionType={'edit'} />
      </PermissionChecker>
    );
  };

  componentWillUnmount(): void {
    useCampaignStore.setState({ lockBrand: false });
  }
  renderCreateCampaignView = (localeMeta, props) => {
    return (
      <PermissionChecker
        permissionAware={this.modifyPermission}
        redirectTo={`${props.match.url}/${ROUTE_PATH.ERROR403}`}
      >
        <CreateCampaignView
          {...props}
          model={this.props.model.getCampaignCreateModel(localeMeta)}
        />
      </PermissionChecker>
    );
  };

  renderEditCampaignView = (localeMeta, props) => {
    return (
      <PermissionChecker
        permissionAware={this.modifyPermission}
        redirectTo={`${props.match.url}/${ROUTE_PATH.ERROR403}`}
      >
        <CreateCampaignView
          {...props}
          model={this.props.model.getCampaignEditModel(
            props.match.params.campaignId,
            localeMeta,
          )}
        />
      </PermissionChecker>
    );
  };

  renderCampaignDetailView = (localeMeta, props) => {
    const campaignId = props.match.params.campaignId;
    return (
      <PermissionChecker
        permissionAware={this.modifyPermission}
        redirectTo={`${props.match.url}/${ROUTE_PATH.ERROR403}`}
      >
        <EditCampaignView
          {...props}
          model={this.props.model.getCampaignEditModel(campaignId, localeMeta)}
        />
      </PermissionChecker>
    );
  };

  renderCampaignCopyView = (localeMeta, props) => {
    return (
      <PermissionChecker
        permissionAware={this.modifyPermission}
        redirectTo={`${props.match.url}/${ROUTE_PATH.ERROR403}`}
      >
        <CopyCampaignView actionType={'copy'} />
      </PermissionChecker>
    );
  };

  renderCampaignSplitView = (localeMeta, props) => {
    const campaignId = props.match.params.campaignId;
    return (
      <PermissionChecker
        permissionAware={this.modifyPermission}
        redirectTo={`${props.match.url}/${ROUTE_PATH.ERROR403}`}
      >
        <SplitCampaignView
          {...props}
          model={this.props.model.getCampaignSplitModel(campaignId, localeMeta)}
        />
      </PermissionChecker>
    );
  };

  redirectToL1Object = (props) => {
    const match = props.match.url.match(/\/orders\/\d+\//);
    return <Redirect to={`${match[0].slice(0, -1)}`} />;
  };

  render() {
    return (
      <div className={styles.container}>
        <CoreContext.Consumer>
          {(coreContext) => {
            const localeMeta = coreContext?.accountManager.localeMeta;
            return (
              <Switch>
                <Route
                  path={`${this.props.match.url}/select-adType`}
                  render={_.partial(this.renderSelectAdTypeView, localeMeta)}
                />
                <Route
                  path={`${this.props.match.url}/create`}
                  render={_.partial(
                    this.renderNewCreateCampaignView,
                    localeMeta,
                  )}
                />
                <Route
                  exact
                  path={`${this.props.match.url}/:campaignId/edit`}
                  render={_.partial(this.renderNewEditCampaignView, localeMeta)}
                />
                <Route
                  exact
                  path={`${this.props.match.url}/:campaignId/oldEdit`}
                  render={_.partial(this.renderEditCampaignView, localeMeta)}
                />
                <Route
                  exact
                  path={`${this.props.match.url}/:campaignId/copy`}
                  render={_.partial(this.renderCampaignCopyView, localeMeta)}
                />
                <Route
                  exact
                  path={`${this.props.match.url}/:campaignId/split`}
                  render={_.partial(this.renderCampaignSplitView, localeMeta)}
                />
                <Route render={this.redirectToL1Object} />
              </Switch>
            );
          }}
        </CoreContext.Consumer>
      </div>
    );
  }
}

export const RtbCampaigns = withRouter(DefaultRtbCampaigns);
